<template>
    <q-btn
            v-show="total"
            :label="label"
            color="primary"
            size="sm"
            no-caps
            @click="$emit('update:modelValue', !modelValue)"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    total: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label(): string {
      const operation = this.modelValue ? 'Less' : 'All';
      return `View ${operation} (${this.total})`;
    },
  },
});
</script>
